"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONNECT_METHOD_FETCHMSG = exports.CONNECT_METHOD_RECEIVE = exports.CONNECT_METHOD_UNSUB = exports.CONNECT_METHOD_SUB = exports.CONNECT_METHOD_PUBLISH = exports.CONNECT_METHOD_LOGIN = exports.CONNECT_METHOD_PUSH = void 0;
// --------------- ws methods -------------
exports.CONNECT_METHOD_PUSH = "push";
exports.CONNECT_METHOD_LOGIN = "login";
exports.CONNECT_METHOD_PUBLISH = "publish";
exports.CONNECT_METHOD_SUB = "subscribe";
exports.CONNECT_METHOD_UNSUB = "unsubscribe";
exports.CONNECT_METHOD_RECEIVE = "receive";
exports.CONNECT_METHOD_FETCHMSG = "fetchMessages";
